var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m51 8c2.21 0 4 1.79 4 4v39.64185c0 2.21-1.79 4-4 4h-44c-2.21 0-4-1.79-4-4v-39.64185c0-2.21 1.79-4 4-4z",
    fill: "#ded8d0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7 55.64185h44c2.21002 0 4-1.79004 4-4v-21.64185c-9.46356 10.3537-25.47406 17.97064-52 19.3927v2.24915c0 2.20996 1.78998 4 4 4z",
    fill: "#c9c4bd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 51,
    fill: "#f5a947",
    r: 11
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m57.59154 42.20866c1.38051 1.83833 2.20846 4.1154 2.20846 6.59134 0 6.07511-4.92489 11-11 11-2.47601 0-4.75301-.82802-6.5914-2.20859 2.00684 2.67218 5.1923 4.40859 8.7914 4.40859 6.07511 0 11-4.92489 11-11 0-3.5991-1.73634-6.7845-4.40846-8.79134z",
    fill: "#f09d3a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m55 18h-52v-6c0-2.20914 1.79086-4 4-4h44c2.20914 0 4 1.79086 4 4z",
    fill: "#e34e4b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m12 13c-1.10457 0-2-.89543-2-2v-6c0-1.10457.89543-2 2-2 1.10457 0 2 .89543 2 2v6c0 1.10457-.89543 2-2 2z",
    fill: "#f5a947"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m23 13c-1.10457 0-2-.89543-2-2v-6c0-1.10457.89543-2 2-2 1.10457 0 2 .89543 2 2v6c0 1.10457-.89543 2-2 2z",
    fill: "#f5a947"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m35 13c-1.10458 0-2-.89543-2-2v-6c0-1.10457.89543-2 2-2 1.10457 0 2 .89543 2 2v6c0 1.10457-.89543 2-2 2z",
    fill: "#f5a947"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m46 13c-1.10458 0-2-.89543-2-2v-6c0-1.10457.89543-2 2-2 1.10457 0 2 .89543 2 2v6c0 1.10457-.89543 2-2 2z",
    fill: "#f5a947"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m9 23h6v6h-6z",
    fill: "#50b6cf"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m20 23h6v6h-6z",
    fill: "#50b6cf"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m31 23h6v6h-6z",
    fill: "#50b6cf"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m42 23h6v6h-6z",
    fill: "#50b6cf"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m9 34h6v6h-6z",
    fill: "#50b6cf"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m20 34h6v6h-6z",
    fill: "#50b6cf"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m31 34h6v6h-6z",
    fill: "#50b6cf"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m42 34h6v6h-6z",
    fill: "#50b6cf"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m9 45h6v6h-6z",
    fill: "#50b6cf"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m20 45h6v6h-6z",
    fill: "#50b6cf"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m31 45h6v6h-6z",
    fill: "#50b6cf"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0d0f23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56 40.10529v-28.10529c0-2.75684-2.24316-5-5-5h-2v-2c0-1.6543-1.3457-3-3-3s-3 1.3457-3 3v2h-5v-2c0-1.6543-1.3457-3-3-3s-3 1.3457-3 3v2h-6v-2c0-1.6543-1.3457-3-3-3s-3 1.3457-3 3v2h-5v-2c0-1.6543-1.3457-3-3-3s-3 1.3457-3 3v2h-2c-2.75684 0-5 2.24316-5 5v40c0 2.75684 2.24316 5 5 5h33.62347c2.07868 3.58081 5.94617 6 10.37653 6 6.61719 0 12-5.38281 12-12 0-4.83142-2.87561-8.99408-7-10.89471zm-11-35.10529c0-.55176.44824-1 1-1s1 .44824 1 1v6c0 .55176-.44824 1-1 1s-1-.44824-1-1zm-11 0c0-.55176.44824-1 1-1s1 .44824 1 1v6c0 .55176-.44824 1-1 1s-1-.44824-1-1zm-12 0c0-.55176.44824-1 1-1s1 .44824 1 1v6c0 .55176-.44824 1-1 1s-1-.44824-1-1zm-11 0c0-.55176.44824-1 1-1s1 .44824 1 1v6c0 .55176-.44824 1-1 1s-1-.44824-1-1zm-4 4h2v2c0 1.6543 1.3457 3 3 3s3-1.3457 3-3v-2h5v2c0 1.6543 1.3457 3 3 3s3-1.3457 3-3v-2h6v2c0 1.6543 1.3457 3 3 3s3-1.3457 3-3v-2h5v2c0 1.6543 1.3457 3 3 3s3-1.3457 3-3v-2h2c1.6543 0 3 1.3457 3 3v5h-50v-5c0-1.6543 1.3457-3 3-3zm0 46c-1.6543 0-3-1.3457-3-3v-33h50v20.39484c-.96082-.24866-1.96246-.39484-3-.39484-.6828 0-1.34808.07056-2 .1806v-5.1806c0-.55273-.44727-1-1-1h-6c-.55273 0-1 .44727-1 1v6c0 .55273.44727 1 1 1h2.38086c-3.23914 2.15106-5.38086 5.82843-5.38086 10 0 1.40411.25494 2.74664.70001 4zm40-16h-4v-4h4zm4 22c-5.51367 0-10-4.48633-10-10s4.48633-10 10-10 10 4.48633 10 10-4.48633 10-10 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52 49.2774v-6.2774h-2v6.2774c-.59528.34644-1 .98413-1 1.7226 0 .10126.01526.19836.02979.29553l-3.65479 2.92322 1.25 1.5625 3.65161-2.92133c.22492.08759.46753.14008.72339.14008 1.10455 0 2-.89545 2-2 0-.73846-.40472-1.37616-1-1.7226z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 22h-6c-.55273 0-1 .44727-1 1v6c0 .55273.44727 1 1 1h6c.55273 0 1-.44727 1-1v-6c0-.55273-.44727-1-1-1zm-1 6h-4v-4h4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 22h-6c-.55273 0-1 .44727-1 1v6c0 .55273.44727 1 1 1h6c.55273 0 1-.44727 1-1v-6c0-.55273-.44727-1-1-1zm-1 6h-4v-4h4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 22h-6c-.55273 0-1 .44727-1 1v6c0 .55273.44727 1 1 1h6c.55273 0 1-.44727 1-1v-6c0-.55273-.44727-1-1-1zm-1 6h-4v-4h4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 30h6c.55273 0 1-.44727 1-1v-6c0-.55273-.44727-1-1-1h-6c-.55273 0-1 .44727-1 1v6c0 .55273.44727 1 1 1zm1-6h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 33h-6c-.55273 0-1 .44727-1 1v6c0 .55273.44727 1 1 1h6c.55273 0 1-.44727 1-1v-6c0-.55273-.44727-1-1-1zm-1 6h-4v-4h4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 33h-6c-.55273 0-1 .44727-1 1v6c0 .55273.44727 1 1 1h6c.55273 0 1-.44727 1-1v-6c0-.55273-.44727-1-1-1zm-1 6h-4v-4h4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 33h-6c-.55273 0-1 .44727-1 1v6c0 .55273.44727 1 1 1h6c.55273 0 1-.44727 1-1v-6c0-.55273-.44727-1-1-1zm-1 6h-4v-4h4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 44h-6c-.55273 0-1 .44727-1 1v6c0 .55273.44727 1 1 1h6c.55273 0 1-.44727 1-1v-6c0-.55273-.44727-1-1-1zm-1 6h-4v-4h4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 44h-6c-.55273 0-1 .44727-1 1v6c0 .55273.44727 1 1 1h6c.55273 0 1-.44727 1-1v-6c0-.55273-.44727-1-1-1zm-1 6h-4v-4h4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 44h-6c-.55273 0-1 .44727-1 1v6c0 .55273.44727 1 1 1h6c.55273 0 1-.44727 1-1v-6c0-.55273-.44727-1-1-1zm-1 6h-4v-4h4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.0d27522dbcc5001d8e84e30c2904ef0b.svg";
export { ForwardRef as ReactComponent };